import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Button, Table, Card, CardHeader, CardBody, CardFooter, CardLink, CardText, FormGroup, Label, Input } from "reactstrap"
import axios from "axios";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest, ResponseRequestGeneric } from 'components/Types/GeneralTypes';
import { HorarioLaboralServidor, InformacionDetalleES, InformacionGeneral, ModalDetalleES, RegistroEntradaSalida, ModalJustificacionES, TablaDetalleES } from 'components/UsuarioGeneral/Registro Entrada Salida/typesRegistroEntradaSalida';

import AlertNew, { TiposAlerta } from 'components/Varios/AlertNew';
import { alertService } from 'components/Varios/alert_service';
import Cargando from 'components/Varios/Cargando';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import PDFViewer from 'components/Varios/PDFViewer';
import Datepicker from 'components/Varios/Datepicker';
import { isWeekday, isFeriadoFilter, isFeriado, } from 'functions/CalendarFunctions';
import { ObtenerFechaFromIsoFormat, SumarDiasFecha, SumarMesesFecha, ParseHorasFormato, AgregarHoraAFecha, ObtenerFechaLaboralDeSuma } from 'functions/DatesFunctions';
import { DownloadDocument } from 'helpers/files';
import configData from "config.json";
import { authHeaderWithToken } from "helpers/auth-header";
import { authenticationService } from 'services/authentication.service';
import add from 'date-fns/add'
import TdSeeMoreContent from 'components/Varios/Tabla/TdSeeMoreContent';
import TimePickerComponent from 'components/Varios/TimePicker/CustomTimePicker';
import { ESTADOS_CON_NOVEDAD, ESTADO_REGISTRO_JUSTIFICADO, MENSAJE_ADVERTENCIA_LAPSO_SOLICITUD } from '../../UsuarioGeneral/Registro Entrada Salida/RegistroEntradaSalidaAlmuerzo';

import "../../../assets/scss/Marcaciones/RegistroMarcacionDirectivo.scss"
import BotonMarcacionEntradaSalida, { TipoJornadaBotonMarcacion, TipoSituacionBotonMarcacion } from 'components/UsuarioGeneral/Registro Entrada Salida/BotonMarcacionEntradaSalida';
import { CerrarLocalStorageMensajeMarcacion, CreateLocalStorageMensajeMarcacion, KEY_SHOWMODAL_MARCACION_AVISO, VerifyShowMensajeMarcacionStorage } from 'functions/LocalStorageFunctions';
import COMUNICADOMARCACION from "../../../assets/img/ComunicadoMarcacionTH.jpg"
import { HorarioLaboralServidorPermisosHoras } from 'components/UsuarioGeneral/Vacaciones/Solicitud Vacaciones/TypesSolicitudVacaciones';
import { ObtenerHorarioLaboralEnFecha } from 'components/UsuarioGeneral/Vacaciones/Solicitud Vacaciones/FunctionsSolicitudVacaciones';
import { Link } from 'react-router-dom';
import { ROUTE_HISTORIAL_MARCACIONES } from 'Context/SideBarContext';
import { showAlert } from 'components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras';


export const SELECT_INICIO_FIN_RECESO = "Inicio y fin del receso/almuerzo";
export const SELECT_INICIO_RECESO = "Inicio del receso/almuerzo";
export const SELECT_FIN_RECESO = "Fin del receso/almuerzo"

const SELECT_INICIO_LABORAL = "Inicio jornada laboral";
const SELECT_FIN_LABORAL = "Fin de la jornada laboral";
export const SELECT_INICIO_FIN_LABORAL = "Inicio y fin de la jornada laboral"


const ESTADO_LABORAL_INCUMPLIDO = "Jornada incumplida";


export const OPCIONES_SELECT_MARCACION = [SELECT_INICIO_RECESO, SELECT_FIN_RECESO, SELECT_INICIO_FIN_RECESO, SELECT_INICIO_LABORAL, SELECT_FIN_LABORAL, SELECT_INICIO_FIN_LABORAL];
export const OPCIONES_SELECT_MOTIVO = ["Descuido personal", "Distracción", "Olvido", "Omisión involuntaria"];
export const TIEMPO_MIN_ALMUERZO = 25;
export const TIEMPO_MAX_ALMUERZO = 30;


export function ValidarMensajeExpiracionProxima(infoDetalle: TablaDetalleES, tipoJornada: "A" | "L") {




    if (tipoJornada === "L") {
        return infoDetalle.estadol !== ESTADO_REGISTRO_JUSTIFICADO && infoDetalle.estadosolicitudl !== "N" && infoDetalle.fechaVencimientol && infoDetalle.estadosolicitudl !== "A" && infoDetalle.estadosolicitudl !== "J" && infoDetalle.estadosolicitudl !== "V" && infoDetalle.estadosolicituda !== "O";
    }
    else {
        return infoDetalle.estadoa !== ESTADO_REGISTRO_JUSTIFICADO && infoDetalle.estadosolicituda !== "N" && infoDetalle.fechaVencimientoa && infoDetalle.estadosolicituda !== "A" && infoDetalle.estadosolicituda !== "J" && infoDetalle.estadosolicituda !== "V" && infoDetalle.estadosolicituda !== "O";
    }


}

export function ValidarMensajeSolicitudExpirada(infoDetalle: TablaDetalleES, tipoJornada: "A" | "L", fechaActual: Date) {
    if (tipoJornada === "L") {
        return infoDetalle.estadol !== ESTADO_REGISTRO_JUSTIFICADO && infoDetalle.estadosolicitudl !== "N" && !infoDetalle.fechaVencimientoRecuperacionl && infoDetalle.fechaVencimientol && infoDetalle.cantidadSolicitudesVencidasl < 2 && infoDetalle.estadosolicitudl === "V" && fechaActual.getTime() > new Date(infoDetalle.fechaVencimientol).getTime()
    } else {
        return infoDetalle.estadoa !== ESTADO_REGISTRO_JUSTIFICADO && infoDetalle.estadosolicituda !== "N" && !infoDetalle.fechaVencimientoRecuperaciona && infoDetalle.fechaVencimientoa && infoDetalle.cantidadSolicitudesVencidasa < 2 && infoDetalle.estadosolicituda === "V" && fechaActual.getTime() > new Date(infoDetalle.fechaVencimientoa).getTime()
    }
}

export function ValidarMensajeSolicitudRecuperacionNoEjecutada(infoDetalle: TablaDetalleES, tipoJornada: "A" | "L", fechaActual: Date, nuevaFechaVencimiento: Date) {
    if (tipoJornada === "L") {
        return infoDetalle.estadol !== ESTADO_REGISTRO_JUSTIFICADO && infoDetalle.estadosolicitudl !== "N" && infoDetalle.fechaVencimientoRecuperacionl && infoDetalle.cantidadSolicitudesVencidasl < 2 && infoDetalle.estadosolicitudl === "V" && fechaActual.getTime() <= new Date(nuevaFechaVencimiento).getTime()
    } else {
        return infoDetalle.estadoa !== ESTADO_REGISTRO_JUSTIFICADO && infoDetalle.estadosolicituda !== "N" && infoDetalle.fechaVencimientoRecuperaciona && infoDetalle.cantidadSolicitudesVencidasa < 2 && infoDetalle.estadosolicituda === "V" && fechaActual.getTime() <= new Date(nuevaFechaVencimiento).getTime()
    }
}

export function ValidarMensajeSolicitudRecuperacionNoEjecutadaVencida(infoDetalle: TablaDetalleES, tipoJornada: "A" | "L", fechaActual: Date, nuevaFechaVencimiento: Date) {
    if (tipoJornada === "L") {
        return infoDetalle.estadol !== ESTADO_REGISTRO_JUSTIFICADO && infoDetalle.estadosolicitudl !== "N" && infoDetalle.fechaVencimientoRecuperacionl && infoDetalle.cantidadSolicitudesVencidasl < 2 && infoDetalle.estadosolicitudl === "V" && fechaActual.getTime() > new Date(nuevaFechaVencimiento).getTime()
    } else {
        return infoDetalle.estadoa !== ESTADO_REGISTRO_JUSTIFICADO && infoDetalle.estadosolicituda !== "N" && infoDetalle.fechaVencimientoRecuperaciona && infoDetalle.cantidadSolicitudesVencidasa < 2 && infoDetalle.estadosolicituda === "V" && fechaActual.getTime() > new Date(nuevaFechaVencimiento).getTime()
    }
}

export default function DirectivoRegistroEntradaSalida() {
    const defaultState: RegistroEntradaSalida = {
        idpersona: 0,
        tipomarcada: "",
        tipojornada: "",
        entradal: "",
        salidal: "",
        entradaa: "",
        salidaa: "",
        duracionl: "",
        duraciona: "",
        fecha: "",
        fechar: "",
        estadol: "",
        estadoa: "",
        ip: "",
        justificaciontipo: "",
        justificacionmotivo: "",
    }
    const defaultStateH: HorarioLaboralServidor = {
        puedemarcarl: "N",
        puedemarcarlE: "N",
        puedemarcarlS: "N",
        puedemarcara: "N",
        puedemarcaraE: "N",
        puedemarcaraS: "N",
        nocturno: "N",
        horaentradal: "",
        horasalidal: "",
        horaentradaa: "",
        horamaximaentradaa: "",
        horasalidaa: "",
        mensaje: "",
        fechahora: (new Date().getTime()).toString(),
        fecha: "",
    }
    const defaultStateI: InformacionGeneral = {
        marcacion_dia: defaultState,
        //lista_registro: [],
        marcacion_horario: defaultStateH,
        //feriados: [],
        //ultimodiames: 0
    }
    const defaultStateModalDetalleES: ModalDetalleES = {
        loadingInformacion: false,
        tabladetalle: undefined,
        fecha: ""
    }
    const defaultStateModalJusticicacionES: ModalJustificacionES = {
        loadingInformacion: false,
        tabladetalle: undefined,
        fecha: "",
        entrada: "",
        salida: "",
        tipo: "",
        exceso: "",
        url: "",
        tipojornada: "A"
    }

    const [loading, setloading] = useState<boolean>(false)
    const [loadingDatos, setloadingDatos] = useState<boolean>(false)
    const [datosMarcacion, setdatosMarcacion] = useState<InformacionGeneral>(defaultStateI)
    const [stateModalDetalleES, setstateModalDetalleES] = useState<ModalDetalleES>(defaultStateModalDetalleES)
    const [stateModalJustificacionES, setstateModalJustificacionES] = useState<ModalJustificacionES>(defaultStateModalJusticicacionES)
    var [date, setDate] = useState(new Date())
    const [Ip, setIp] = useState<string>("")
    const [selectMarcacion, setselectMarcacion] = useState<string>("def")
    const [selectMotivo, setselectMotivo] = useState<string>("def")
    const [horaDesde, setHoraDesde] = useState<string>("")
    const [horaHasta, setHoraHasta] = useState<string | null>("")
    const [errorHoras, seterrorHoras] = useState<string>("")
    const [horaDesdeR, setHoraDesdeR] = useState<string>("")
    const [horaHastaR, setHoraHastaR] = useState<string>("")
    const [habilitarIngresoHoras, sethabilitarIngresoHoras] = useState<boolean>(false)
    const [fechaPermisoHora, setfechaPermisoHora] = useState<Date | null>(null)
    const [mostrarModalMarcacion, setmostrarModalMarcacion] = useState<boolean>(false)

    const [horarioParaPermisoHora, sethorarioParaPermisoHora] = useState<HorarioLaboralServidorPermisosHoras | undefined>(undefined)
    const [excesoMarcacion, setexcesoMarcacion] = useState<string>("")
    const [loadingHorarioPermisoHora, setloadingHorarioPermisoHora] = useState<boolean>(false)



    function handleError() {
    }
    function handleErrorInformacion() {
        alertService.error("Ha ocurrido un inconveniente");
    }

    async function getIp() {
        const response = await axios.get("https://api.ipify.org/?format=json")
        setIp(response.data.ip)
    }

    async function CrearRegistroMarcacion(_tipomarcada_, _tipojornada_) {
        var resultado: ResponseRequest = { status: 200 };

        var userData: UserData = authenticationService.currentUserValue;

        const marcacion: RegistroEntradaSalida = {
            idpersona: userData.idpersona,
            tipomarcada: _tipomarcada_,
            tipojornada: _tipojornada_,
            entradal: "",
            salidal: "",
            entradaa: "",
            salidaa: "",
            duracionl: "",
            duraciona: "",
            fecha: "",
            fechar: "",
            estadol: "",
            estadoa: "",
            ip: Ip,
            justificaciontipo: "",
            justificacionmotivo: ""
        }

        const URL = `${configData.SERVER_URL}RegistroEntradaSalida/PostGuardarMarcaciones`;
        try {
            const respuesta = await axios.post(URL, marcacion, {
                headers: authHeaderWithToken(userData.token)
            })

            resultado = { status: respuesta.status, dataResponse: respuesta.data }
        } catch (error) {
            var mensaje: string = "Ha ocurrido un inconveniente";
            if (axios.isAxiosError(error) && error.response) {
            }
        }
        return resultado;
    }

    async function HandleClickRegistrarMarcacionE() {
        setloading(true)
        const resultado: ResponseRequest = await CrearRegistroMarcacion("E", "L");
        if (resultado.status === 200 && resultado.dataResponse && resultado.dataResponse.strEstado === "S") {
            GetInfoMarcacion();
            showAlert(resultado.dataResponse.strMensaje,true)
        }
        else if (resultado.status === 200 && resultado.dataResponse && resultado.dataResponse.strEstado === "N") {
            GetInfoMarcacion();
            showAlert(resultado.dataResponse.strMensaje,false)
        }
        else {
            showAlert(resultado.errorMessage??"",false);
        }
        setloading(false)
    }

    async function HandleClickRegistrarMarcacionS() {
        setloading(true)
        setmostrarModalMarcacion(true)
        const resultado: ResponseRequest = await CrearRegistroMarcacion("S", "L");
        if (resultado.status === 200 && resultado.dataResponse && resultado.dataResponse.strEstado === "S") {
            GetInfoMarcacion();
            showAlert(resultado.dataResponse.strMensaje,true)
        }
        else if (resultado.status === 200 && resultado.dataResponse && resultado.dataResponse.strEstado === "N") {
            GetInfoMarcacion();
            showAlert(resultado.dataResponse.strMensaje,false)
        }
        else {
            showAlert(resultado.errorMessage??"",false);
        }
        setloading(false)
    }

    async function HandleClickRegistrarMarcacionEA() {
        setloading(true)
        const resultado: ResponseRequest = await CrearRegistroMarcacion("E", "A");
        if (resultado.status === 200 && resultado.dataResponse && resultado.dataResponse.strEstado === "S") {
            GetInfoMarcacion();
            showAlert(resultado.dataResponse.strMensaje,true)
        }
        else if (resultado.status === 200 && resultado.dataResponse && resultado.dataResponse.strEstado === "N") {
            GetInfoMarcacion();
            showAlert(resultado.dataResponse.strMensaje,false)
        }
        else {
            showAlert(resultado.errorMessage??"",false);
        }
        setloading(false)
    }

    async function HandleClickRegistrarMarcacionSA() {
        setloading(true)
        const resultado: ResponseRequest = await CrearRegistroMarcacion("S", "A");
        if (resultado.status === 200 && resultado.dataResponse && resultado.dataResponse.strEstado === "S") {
            GetInfoMarcacion();
            showAlert(resultado.dataResponse.strMensaje,true)
        }
        else if (resultado.status === 200 && resultado.dataResponse && resultado.dataResponse.strEstado === "N") {
            GetInfoMarcacion();
            showAlert(resultado.dataResponse.strMensaje,false)
        }
        else {
            showAlert(resultado.errorMessage??"",false);
        }
        setloading(false)
    }

    async function obtenerDetalleES(fecha: string) {
        const infoUsuario: UserData = authenticationService.currentUserValue;

        var respuestaResponse: ResponseRequest = { status: -1 }
        const URL = configData.SERVER_URL + "RegistroEntradaSalida/DetalleES/" + fecha
        try {
            const respuesta = await axios.get(URL, {
                headers: authHeaderWithToken(infoUsuario.token)
            })

            const dataResponse: InformacionDetalleES = respuesta.data;

            respuestaResponse = {
                status: respuesta.status,
                dataResponse
            }
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                respuestaResponse = { status: error.response.status }
            }
        }

        return respuestaResponse;
    }

    async function Justificacion(_tipomarcada_, tipoJornada: "A" | "L") {
        var resultado: ResponseRequest = { status: 200 };

        var userData: UserData = authenticationService.currentUserValue;

        var fecha_;
        if (_tipomarcada_ === "E")
            fecha_ = fechaPermisoHora;
        else
            fecha_ = stateModalJustificacionES.fecha;

        const marcacion: RegistroEntradaSalida = {
            idpersona: userData.idpersona,
            tipomarcada: _tipomarcada_,//E exceso o Incumplimiento  - A ausencia, no marco correspondiente
            tipojornada: tipoJornada,
            entradal: "",
            salidal: "",
            entradaa: horaDesde,
            salidaa: horaHasta,
            duracionl: "",
            duraciona: "",
            fecha: fecha_,
            fechar: stateModalJustificacionES.fecha,
            estadol: "",
            estadoa: "",
            ip: Ip,
            justificaciontipo: selectMarcacion,
            justificacionmotivo: selectMotivo,
        }

        const URL = `${configData.SERVER_URL}RegistroEntradaSalida/PostGuardarJustificacion`;
        try {
            const respuesta = await axios.post(URL, marcacion, {
                headers: authHeaderWithToken(userData.token)
            })

            resultado = { status: respuesta.status, dataResponse: respuesta.data }
        } catch (error) {
            var mensaje: string = "Ha ocurrido un inconveniente";
            if (axios.isAxiosError(error) && error.response) {
            }
        }
        return resultado;
    }

    async function GetVistaPreviaFormularioJustificacion(_tipomarcada_, tipoJornada: "A" | "L") {
        var resultado: ResponseRequestGeneric<string> = { status: 200, dataResponse: "" };

        var userData: UserData = authenticationService.currentUserValue;

        var fecha_;
        if (_tipomarcada_ === "E")
            fecha_ = fechaPermisoHora;
        else
            fecha_ = stateModalJustificacionES.fecha;

        const marcacion: RegistroEntradaSalida = {
            idpersona: userData.idpersona,
            tipomarcada: _tipomarcada_,//E exceso o Incumplimiento , A ausencia, no marco correspondiente
            tipojornada: tipoJornada,
            entradal: "",
            salidal: "",
            entradaa: horaDesde,
            salidaa: horaHasta,
            duracionl: "",
            duraciona: "",
            fecha: fecha_,
            fechar: stateModalJustificacionES.fecha,
            estadol: "",
            estadoa: "",
            ip: Ip,
            justificaciontipo: selectMarcacion,
            justificacionmotivo: selectMotivo,
        }

        var URL = `${configData.SERVER_URL}RegistroEntradaSalida/VistaPreviaFormularioIngresoJustificacion`;

        if (_tipomarcada_ === "E") {
            var URL = `${configData.SERVER_URL}RegistroEntradaSalida/VistaPreviaFormularioIngresoRecuperacion`;
        }

        try {
            const respuesta = await axios.post(URL, marcacion,
                {
                    headers: authHeaderWithToken(userData.token),
                    responseType: "blob"
                }
            )

            const blob_resource = await respuesta.data;
            const url_documento = window.URL.createObjectURL(blob_resource);
            resultado = { status: respuesta.status, dataResponse: url_documento }
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

                resultado = { status: error.response.status, errorMessage: mensaje }
            }
            else if (axios.isAxiosError(error) && !error.response) {
                resultado = { status: -1, errorMessage: "No ha sido posible contactar con el servidor. Intente más tarde." }
            }
        }
        return resultado;
    }

    async function HandleClickBotonJustificacion() {
        setloading(true)

        const resultado: ResponseRequest = await Justificacion(stateModalJustificacionES.tipo, stateModalJustificacionES.tipojornada);
        if (resultado.status === 200) {
            if (resultado.dataResponse.strEstado === "N") {
                ReiniciarJustificacionES();
                alertService.error(resultado.dataResponse.strMensaje);
            }
            else {
                ReiniciarJustificacionES();
                alertService.success(resultado.dataResponse.strMensaje);
            }
            GetInfoMarcacion();
            verDetalleES(datosMarcacion.marcacion_horario.fecha);
        }
        else {
            showAlert(resultado.errorMessage??"",false);
            //Esto cierra el modal de justificaciones
            setstateModalJustificacionES(defaultStateModalJusticicacionES)
            //Se trata de cerrar el modal de detalles tambien
            setstateModalDetalleES(defaultStateModalDetalleES)
        }

        setloading(false)
    }

    const HandleClickBotonVistaPreviaSolicitudJustificacion = useCallback(
        async () => {
            setloading(true)

            const resultado: ResponseRequestGeneric<string> = await GetVistaPreviaFormularioJustificacion(stateModalJustificacionES.tipo, stateModalJustificacionES.tipojornada);
            if (resultado.status === 200 && resultado.dataResponse !== undefined) {
                //GetInfoMarcacion();

                const copiaState: ModalJustificacionES = { ...stateModalJustificacionES, url: resultado.dataResponse }

                setstateModalJustificacionES(copiaState);
            }
            else {
                showAlert(resultado.errorMessage??"",false);
                //Esto cierra el modal de justificaciones
                setstateModalJustificacionES(defaultStateModalJusticicacionES)
                //Se trata de cerrar el modal de detalles tambien
                setstateModalDetalleES(defaultStateModalDetalleES)
            }
            setloading(false)
        },
        [loading, datosMarcacion, stateModalJustificacionES, selectMarcacion, selectMotivo, horaDesde, horaHasta, errorHoras],
    )

    const HandleClickBotonVistaPreviaSolicitudJustificacionRecuperacion = useCallback(
        async () => {
            setloading(true)

            const resultado: ResponseRequestGeneric<string> = await GetVistaPreviaFormularioJustificacion(stateModalJustificacionES.tipo, stateModalJustificacionES.tipojornada);
            if (resultado.status === 200 && resultado.dataResponse !== undefined) {
                //GetInfoMarcacion();

                const copiaState: ModalJustificacionES = { ...stateModalJustificacionES, url: resultado.dataResponse }

                setstateModalJustificacionES(copiaState);
            }
            else {
                showAlert(resultado.errorMessage??"",false);
                setstateModalJustificacionES(defaultStateModalJusticicacionES)
                //Se trata de cerrar el modal de detalles tambien
                setstateModalDetalleES(defaultStateModalDetalleES)
            }
            setloading(false)
        },
        [loading, datosMarcacion, stateModalJustificacionES, selectMarcacion, selectMotivo, fechaPermisoHora, horaDesde, horaHasta, errorHoras]);

    const BotonJustificacionExceso = useMemo(() => {
        const deshabilitarBoton = errorHoras !== "" || fechaPermisoHora == null || horaDesde === "" || horaHasta === "" || selectMotivo === "def" || loading;
        return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled={deshabilitarBoton} onClick={() => HandleClickBotonJustificacion()}>Aceptar</Button>)
    }, [loading, datosMarcacion, stateModalJustificacionES, selectMarcacion, selectMotivo, fechaPermisoHora, horaDesde, horaHasta, errorHoras]);

    const BotonVistaPreviaFormularioRecuperacion = useMemo(() => {
        const deshabilitarBoton = errorHoras !== "" || fechaPermisoHora == null || horaDesde === "" || horaHasta === "" || selectMotivo === "def" || loading;
        return (<Button className="secondary" type="button" style={{ float: 'inherit' }} disabled={deshabilitarBoton} onClick={() => HandleClickBotonVistaPreviaSolicitudJustificacionRecuperacion()}>Vista Previa Solicitud</Button>)
    }, [loading, datosMarcacion, stateModalJustificacionES, selectMarcacion, selectMotivo, fechaPermisoHora, horaDesde, horaHasta, errorHoras]);

    const BotonVistaPreviaFormularioJustificacion = useMemo(() => {
        const deshabilitarBoton = errorHoras !== "" || selectMotivo === "def" || selectMarcacion === "def" || horaDesde === "" || horaHasta === "" || loading;
        return (<Button className="secondary" type="button" style={{ float: 'inherit' }} disabled={deshabilitarBoton} onClick={() => HandleClickBotonVistaPreviaSolicitudJustificacion()}>Vista Previa Solicitud</Button>)
    }, [loading, datosMarcacion, stateModalJustificacionES, selectMarcacion, selectMotivo, horaDesde, horaHasta, errorHoras]);

    const BotonJustificacionAusencia = useMemo(() => {
        const deshabilitarBoton = errorHoras !== "" || selectMotivo === "def" || selectMarcacion === "def" || horaDesde === "" || horaHasta === "" || loading;
        return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled={deshabilitarBoton} onClick={() => HandleClickBotonJustificacion()}>Aceptar</Button>)
    }, [loading, datosMarcacion, stateModalJustificacionES, selectMarcacion, selectMotivo, horaDesde, horaHasta, errorHoras]);

    // const DatePickerFechaHora = useCallback(() => {
    //     const fechaActualConTime = new Date();
    //     const fechaActual = new Date(fechaActualConTime.getFullYear(), fechaActualConTime.getMonth(), fechaActualConTime.getDate(), 0, 0, 0);

    //     const feriados = datosMarcacion.feriados.map((val, ind) => {
    //         return new Date(val)
    //     })
    //     var excludeDates = [...feriados];

    //     //const cantidadDiasDespuesSePuedeIngresar = 0;
    //     //const diasARestar = fechaActual.getDay() === 1 ? cantidadDiasDespuesSePuedeIngresar - 2 : fechaActual.getDay() === 0 ? cantidadDiasDespuesSePuedeIngresar - 1 : cantidadDiasDespuesSePuedeIngresar;

    //     var fechaminima = SumarDiasFecha(fechaActual, 1);

    //     //var fechaminimaCalculoDias = new Date(new Date(fechaminima).setHours(0, 0, 0, 0));
    //     //while (feriados.find(c => c.getTime() == fechaminimaCalculoDias.getTime()) !== undefined) {
    //     //    fechaminimaCalculoDias = SumarDiasFecha(fechaminimaCalculoDias, -1)
    //     //}

    //     //fechaminima = fechaminimaCalculoDias

    //     const ultimaFechaDelMes = SumarDiasFecha(fechaActual, (datosMarcacion.ultimodiames - fechaActual.getDate()));

    //     var fechaMaxima = ultimaFechaDelMes

    //     if (stateModalJustificacionES.tipo === "E") {

    //         const stringFechaEvento = stateModalJustificacionES.fecha;
    //         const [diaFechaEvento, mesFechaEvento, anioFechaEvento] = stringFechaEvento.split("/")
    //         const fechaEvento = new Date(+anioFechaEvento, (+mesFechaEvento) - 1, +diaFechaEvento);

    //         const fechaDosDiasDespues = ObtenerFechaLaboralDeSuma(fechaActual, 2, feriados);

    //         if (fechaEvento.getTime() === ultimaFechaDelMes.getTime()) {
    //             fechaMaxima = ObtenerFechaLaboralDeSuma(fechaActual, 2, feriados);
    //         }
    //         else if (fechaDosDiasDespues.getTime() > ultimaFechaDelMes.getTime()) {
    //             fechaMaxima = ObtenerFechaLaboralDeSuma(fechaActual, 2, feriados);
    //         }
    //     }

    //     return (
    //         <Datepicker
    //             value={fechaPermisoHora}
    //             name="fechaPermisoHora"
    //             id="fechaPermisoHora"
    //             onChange={(e) => setfechaPermisoHora(e)}
    //             min={fechaminima}
    //             max={fechaMaxima}
    //             filter={(datefilter: Date) => isWeekday(datefilter) && isFeriadoFilter(datefilter, feriados)}
    //             showDisabledMonthNavigation={true}
    //             excludeDates={excludeDates}
    //             dayClassName={(datefilter: Date) => isFeriado(datefilter, feriados)}
    //         />
    //     )
    // }, [fechaPermisoHora, datosMarcacion, stateModalJustificacionES])

    const OnChangeHoraDesde = useCallback(
        (e: any) => {
            setHoraDesde(e.format('HH:mm'));

            if (selectMarcacion === SELECT_INICIO_FIN_LABORAL || selectMarcacion === SELECT_INICIO_FIN_RECESO) {
                setHoraHasta(null);
            }

        },
        [selectMarcacion],
    )




    function OnChangeHoraHasta(e: any) {
        setHoraHasta(e.format('HH:mm'))
    }

    const inputHoraDesde = useCallback(
        (isdisabled?: boolean) => {

            return (
                // <Input type="time" className="inputTime" value={horaDesde} onChange={(e) => OnChangeHoraDesde(e)} />
                <TimePickerComponent
                    value={horaDesde === "" ? null : horaDesde}
                    onChange={(e) => OnChangeHoraDesde(e)}
                    disabled={isdisabled !== undefined && isdisabled === true}
                />


            )
        },
        [horaDesde]
    )

    const inputHoraHasta = useCallback(
        (tipojornada: "A" | "L" = "A") => {

            var horamin = "12:00";
            var horamax = "15:30";


            if (tipojornada === "L") {
                horamin = "";
                horamax = "";
            }

            return (
                <>

                    {/* <Input 
                        disabled={horaDesde === ""} 
                        type="time" 
                        className="inputTime" 
                        min={horamin} 
                        max={horamax} 
                        value={horaHasta} 
                        onChange={(e) => setHoraHasta(e.target.value)} 
                    /> */}

                    <TimePickerComponent
                        value={horaHasta === "" ? null : horaHasta}
                        onChange={(e) => OnChangeHoraHasta(e)}
                        disabled={horaDesde === "" || horaDesde === null || selectMarcacion === SELECT_INICIO_LABORAL || selectMarcacion === SELECT_INICIO_RECESO}

                    />

                </>
            )
        },
        [horaDesde, horaHasta, errorHoras, selectMarcacion],
    )

    useEffect(() => {
        if (fechaPermisoHora !== null) {

            const VerificarHorarioLaboralEnFecha = async () => {
                setloadingHorarioPermisoHora(true)
                const respuesta = await ObtenerHorarioLaboralEnFecha(fechaPermisoHora);
                if (respuesta.status === 200 && respuesta.dataResponse) {
                    sethorarioParaPermisoHora(respuesta.dataResponse)

                }
                setloadingHorarioPermisoHora(false)
            }

            VerificarHorarioLaboralEnFecha();
        }
    }, [fechaPermisoHora])


    useEffect(() => {
        if (horarioParaPermisoHora && excesoMarcacion !== "" && fechaPermisoHora) {

            var tiempoAlmuerzo = excesoMarcacion.split(':');
            var tiempoAlmuerzoMinutos = (+tiempoAlmuerzo[0]) * 60 + (+tiempoAlmuerzo[1]);
            var [hora_desde, minuto_desde] = horarioParaPermisoHora.horaSalida.split(":");

            const fechaEscogida = new Date(fechaPermisoHora);
            fechaEscogida.setHours(Number(hora_desde), Number(minuto_desde) + +tiempoAlmuerzoMinutos, 0);
            var horahasta = fechaEscogida.getHours() + ":" + fechaEscogida.getMinutes();

            setHoraDesde(horarioParaPermisoHora.horaSalida)
            setHoraHasta(horahasta);
        }
    }, [horarioParaPermisoHora, excesoMarcacion, fechaPermisoHora])





    useEffect(() => {
        if ((horaDesde !== "") && (horaHasta !== "") && horaHasta !== null && stateModalJustificacionES.tipo === "A") {
            const fechaEscogida = new Date();

            const [hora_inicio_almuerzo, minuto_inicio_almuerzo] = datosMarcacion.marcacion_horario.horaentradaa.split(":");
            const [hora_maxima_inicio_almuerzo, minuto_maxima_inicio_almuerzo] = datosMarcacion.marcacion_horario.horamaximaentradaa.split(":");
            const [hora_fin_almuerzo, minuto_fin_almuerzo] = datosMarcacion.marcacion_horario.horasalidaa.split(":");
            const [hora_desde_seleccionada, minuto_desde] = horaDesde.split(":");
            const [hora_hasta_seleccionada, minuto_hasta] = horaHasta.split(":");

            const [hora_inicio_laboral, minuto_inicio_laboral] = datosMarcacion.marcacion_horario.horaentradal.split(":");
            const [hora_fin_laboral, minuto_fin_laboral] = datosMarcacion.marcacion_horario.horasalidal.split(":");


            const horaInicioAlmuerzo = add(fechaEscogida, { hours: +hora_inicio_almuerzo, minutes: +minuto_inicio_almuerzo });
            const horaMaximaInicioAlmuerzo = add(fechaEscogida, { hours: +hora_maxima_inicio_almuerzo, minutes: +minuto_maxima_inicio_almuerzo });

            const horaFinAlmuerzo = add(fechaEscogida, { hours: +hora_fin_almuerzo, minutes: +minuto_fin_almuerzo });

            const horaInicioLaboral = add(fechaEscogida, { hours: +hora_inicio_laboral, minutes: +minuto_inicio_laboral });
            const horaFinLaboral = add(fechaEscogida, { hours: +hora_fin_laboral, minutes: +minuto_fin_laboral });

            const horaDesdeSeleccionada = add(fechaEscogida, { hours: +hora_desde_seleccionada, minutes: +minuto_desde });
            const horaHastaSeleccionada = add(fechaEscogida, { hours: +hora_hasta_seleccionada, minutes: +minuto_hasta });

            if (stateModalJustificacionES.tipojornada === "A") {
                if (horaHastaSeleccionada.getTime() < horaDesdeSeleccionada.getTime()) {
                    seterrorHoras("La hora hasta no puede ser menor a la hora desde");
                }
                else if (horaDesdeSeleccionada.getTime() < horaInicioAlmuerzo.getTime()) {
                    seterrorHoras("La hora desde debe ser despues de las " + datosMarcacion.marcacion_horario.horaentradaa + " horas");
                }
                else if (horaDesdeSeleccionada.getTime() > horaMaximaInicioAlmuerzo.getTime()) {
                    seterrorHoras("La hora desde no puede ser mayor a las " + datosMarcacion.marcacion_horario.horamaximaentradaa + " horas");
                }
                else {
                    var diff = (horaHastaSeleccionada.getTime() - horaDesdeSeleccionada.getTime()) / 1000;
                    diff /= 60;
                    if (Math.abs(Math.round(diff)) > TIEMPO_MAX_ALMUERZO)
                        seterrorHoras("La duración del receso/almuerzo es de 30 minutos");
                    else if (Math.abs(Math.round(diff)) < TIEMPO_MAX_ALMUERZO)
                        seterrorHoras("La duración del receso/almuerzo es de 30 minutos");
                    //else if (Math.abs(Math.round(diff)) < TIEMPO_MIN_ALMUERZO)
                    //seterrorHoras("La duración del receso/almuerzo no puede ser menor a 25 minutos");
                    else
                        seterrorHoras("");
                }
            }
            else if (stateModalJustificacionES.tipojornada === "L") {
                if (horaHastaSeleccionada.getTime() < horaDesdeSeleccionada.getTime()) {
                    seterrorHoras("La hora hasta no puede ser menor a la hora desde");
                }
                else if (selectMarcacion !== SELECT_FIN_LABORAL && horaDesdeSeleccionada.getTime() < horaInicioLaboral.getTime()) {
                    seterrorHoras("La hora desde debe ser despues de las " + datosMarcacion.marcacion_horario.horaentradal + " horas");
                }
                else if (horaDesdeSeleccionada.getTime() > horaFinLaboral.getTime()) {
                    seterrorHoras("La hora desde no puede ser mayor a las " + datosMarcacion.marcacion_horario.horasalidal + " horas");
                }
                else {
                    //var diff = (horaHastaSeleccionada.getTime() - horaDesdeSeleccionada.getTime()) / 1000;
                    //diff /= 60;
                    //if (Math.abs(Math.round(diff)) > TIEMPO_MAX_ALMUERZO)
                    //    seterrorHoras("La duración del receso/almuerzo es de 30 minutos");
                    //else if (Math.abs(Math.round(diff)) < TIEMPO_MAX_ALMUERZO)
                    //    seterrorHoras("La duración del receso/almuerzo es de 30 minutos");
                    //else
                    seterrorHoras("");
                }
            }



        }
        else if ((horaDesde !== "") && (horaHasta !== "") && (horaHasta !== undefined) && horaHasta !== null && stateModalJustificacionES.tipo === "E") {
            const fechaEscogida = new Date();

            const [hora_salida_labroal, minuto_salida_laboral] = datosMarcacion.marcacion_horario.horasalidal.split(":");
            const hora_desde_seleccionada = horaDesde.split(":")[0];
            const minuto_desde = horaDesde.split(":")[1];
            const hora_hasta_seleccionada = horaHasta.split(":")[0];
            const minuto_hasta = horaHasta.split(":")[1];

            const tiempoAlmuerzo = stateModalJustificacionES.exceso.split(':');
            const tiempoAlmuerzoMinutos = (+tiempoAlmuerzo[0]) * 60 + (+tiempoAlmuerzo[1]);

            const horaSalidaLaboral = add(fechaEscogida, { hours: +hora_salida_labroal, minutes: +minuto_salida_laboral });
            const horaDesdeSeleccionada = add(fechaEscogida, { hours: +hora_desde_seleccionada, minutes: +minuto_desde });
            const horaHastaSeleccionada = add(fechaEscogida, { hours: +hora_hasta_seleccionada, minutes: +minuto_hasta });

            if (horaHastaSeleccionada.getTime() < horaDesdeSeleccionada.getTime()) {
                seterrorHoras("La hora hasta no puede ser menor a la hora desde");
            }
            else if (horaDesdeSeleccionada.getTime() < horaSalidaLaboral.getTime()) {
                seterrorHoras("Solo puede recuperar después de la jornada laboral");
            }
            else {
                var diff = (horaHastaSeleccionada.getTime() - horaDesdeSeleccionada.getTime()) / 1000;
                diff /= 60;
                if (Math.abs(Math.round(diff)) !== tiempoAlmuerzoMinutos)
                    seterrorHoras("La recuperación del tiempo debe ser de " + tiempoAlmuerzoMinutos + " minutos");
                else
                    seterrorHoras("");
            }
        }
    }, [stateModalJustificacionES, horaDesde, horaHasta, errorHoras, datosMarcacion, selectMarcacion, horarioParaPermisoHora])

    const contenidoModalJustificacionES: any = useMemo(() => {
        if (stateModalJustificacionES.loadingInformacion) {
            return <Cargando />
        }
        else if (stateModalJustificacionES.fecha !== "" && stateModalJustificacionES.fecha.length === 0) {
            return (
                <>
                    <br />
                    <p className='text-center'>No hay detalle</p>
                </>
            )
        }
        else if (stateModalJustificacionES.fecha !== "" && stateModalJustificacionES.loadingInformacion === false && stateModalJustificacionES.tipo === "E") {
            const tabla =

                <>
                    <div className="content">

                        <Row>
                            <Col xs={12}>
                                <FormGroup>
                                    <span>
                                        Jornada de trabajo que solicita recuperar:
                                    </span>
                                    <p> <i className="fa-regular fa-calendar"></i> {stateModalJustificacionES.fecha} - {stateModalJustificacionES.exceso}</p>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                Fecha y hora que solicita recuperar:
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <Label for="fechaHoraSolicitud">
                                        Fecha
                                    </Label>
                                    {/* {DatePickerFechaHora()} */}
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup>
                                    <Label for="horadesdeSolicitud">
                                        Hora Desde
                                    </Label>
                                    {inputHoraDesde(true)}
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup>
                                    <Label for="horahastaSolicitud">
                                        Hora Hasta
                                    </Label>
                                    {inputHoraHasta()}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <FormGroup>
                                    <span>Motivo por el cual solicita la recuperación:</span>
                                    <Input
                                        type="select"
                                        id="motivomarcacion"
                                        name="motivomarcacion"
                                        value={selectMotivo}
                                        onChange={(e) => setselectMotivo(e.target.value)}
                                        defaultValue={"def"}
                                    >
                                        <option value={"def"}>Seleccione</option>
                                        {
                                            OPCIONES_SELECT_MOTIVO.map((opcion, indiceOpcion) => {
                                                return (
                                                    <option key={"motivomarcacion" + indiceOpcion} value={opcion}>{opcion}</option>
                                                )
                                            })
                                        }
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="rowErroresHoras">
                            <Col xs={12}>
                                <small className='small-error'>{errorHoras}</small>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                {BotonVistaPreviaFormularioRecuperacion}
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12}> {BotonJustificacionExceso} </Col>
                        </Row>
                        {
                            loading &&
                            <Cargando />
                        }
                        {
                            stateModalJustificacionES.url &&
                            <Row>
                                <Col>
                                    <PDFViewer url={stateModalJustificacionES.url} heightValue={"100%"} />

                                </Col>
                            </Row>
                        }
                    </div>

                </>

            return tabla;
        }
        else if (stateModalJustificacionES.fecha !== "" && stateModalJustificacionES.loadingInformacion === false && stateModalJustificacionES.tipo === "A") {

            var opcionesMarcacion = OPCIONES_SELECT_MARCACION;

            if (stateModalJustificacionES.tipojornada === "A") {
                opcionesMarcacion = opcionesMarcacion.slice(0, 3);
            }
            else if (stateModalJustificacionES.tipojornada === "L") {
                opcionesMarcacion = opcionesMarcacion.slice(3);
            }

            const disabledHoraDesdeAusencia = selectMarcacion === SELECT_FIN_LABORAL || selectMarcacion === SELECT_FIN_RECESO

            const tabla =

                <>
                    <div className="content">
                        <Row>
                            <Col xs={12}>
                                <FormGroup>
                                    <span>
                                        Jornada de trabajo que solicita justificar:
                                    </span>
                                    <p> <i className="fa-regular fa-calendar"></i> {stateModalJustificacionES.fecha}</p>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <FormGroup>
                                    <span>Correspondiente a la marcación de:</span>
                                    <Input
                                        type="select"
                                        id="selectmarcacion"
                                        name="selectmarcacion"
                                        value={selectMarcacion}
                                        onChange={(e) => setselectMarcacion(e.target.value)}
                                        defaultValue={"def"}
                                        disabled
                                    >
                                        <option value={"def"}>Seleccione</option>
                                        {
                                            opcionesMarcacion.map((opcion, indiceOpcion) => {
                                                return (
                                                    <option key={"selectmarcacion" + indiceOpcion} value={opcion}>{opcion}</option>
                                                )
                                            })
                                        }
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                Horas que solicita se registre como marcación
                            </Col>
                            <Col md={2}>
                                <FormGroup>
                                    <Label for="horadesdeSolicitud">
                                        Hora Desde
                                    </Label>
                                    {inputHoraDesde(disabledHoraDesdeAusencia)}
                                    {/* <TimePickerComponent
                                        value={horaDesde}
                                        onChange={(e) => setHoraDesde(e.format('HH:mm'))}
                                        disabled={selectMarcacion === SELECT_FIN_LABORAL || selectMarcacion === SELECT_FIN_RECESO}
                                    /> */}
                                    {/* <Input type="time" className="inputTime" value={horaDesde} onChange={(e) => setHoraDesde(e.target.value)} /> */}
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup>
                                    <Label for="horahastaSolicitud">
                                        Hora Hasta
                                    </Label>
                                    {inputHoraHasta(stateModalJustificacionES.tipojornada)}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="rowErroresHoras">
                            <Col xs={12}>
                                <small className='small-error'>{errorHoras}</small>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <FormGroup>
                                    <span>Motivo por el cual no registró la marcación requerida:</span>
                                    <Input
                                        type="select"
                                        id="motivomarcacion"
                                        name="motivomarcacion"
                                        value={selectMotivo}
                                        onChange={(e) => setselectMotivo(e.target.value)}
                                        defaultValue={"def"}
                                    >
                                        <option value={"def"}>Seleccione</option>
                                        {
                                            OPCIONES_SELECT_MOTIVO.map((opcion, indiceOpcion) => {
                                                return (
                                                    <option key={"motivomarcacion" + indiceOpcion} value={opcion}>{opcion}</option>
                                                )
                                            })
                                        }
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                {BotonVistaPreviaFormularioJustificacion}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}> {BotonJustificacionAusencia} </Col>
                        </Row>
                        {
                            loading &&
                            <Cargando />
                        }
                        {
                            stateModalJustificacionES.url &&
                            <Row>
                                <Col xs={12}>
                                    <PDFViewer url={stateModalJustificacionES.url} heightValue={"100%"} />

                                </Col>
                            </Row>
                        }

                    </div>

                </>

            return tabla;
        }
    }, [stateModalJustificacionES, selectMarcacion, selectMotivo, horaDesde, horaHasta, inputHoraHasta, errorHoras, fechaPermisoHora, loading])

    function ReiniciarJustificacionES() {
        setstateModalJustificacionES({ tabladetalle: undefined, loadingInformacion: false, fecha: "", entrada: "", salida: "", tipo: "", exceso: "", url: "", tipojornada: "A" });
        setselectMarcacion("def");
        setselectMotivo("def");
        setfechaPermisoHora(null);
        setHoraDesde("");
        setHoraHasta("");
        seterrorHoras("");
    }

    async function verJutificacionES(fecha: string, entradaa: string, salidaa: string, tipo: string, exceso: string, jornada: "A" | "L" = "A") {


        if (jornada === "A") {
            var nuevafecha = new Date();
            if (entradaa != null)
                nuevafecha.setHours(Number(entradaa.split(":")[0]), Number(entradaa.split(":")[1]), 0);
            else
                nuevafecha.setHours(12, 0, 0);
            var fecha2 = AgregarHoraAFecha(nuevafecha, "0:29");

            if (tipo === "A") {
                if (entradaa != null) {
                    var horaentrada = entradaa.split(":")[0] + ":" + entradaa.split(":")[1];
                    var [hora_desde, minuto_desde] = horaentrada.split(":");
                    var fechaEscogida = new Date();
                    fechaEscogida.setHours(Number(hora_desde), Number(minuto_desde) + +TIEMPO_MAX_ALMUERZO, 0);
                    var horahasta = fechaEscogida.getHours() + ":" + fechaEscogida.getMinutes();
                    setHoraDesde(horaentrada);
                    setHoraHasta(horahasta);
                }
                if (entradaa == null && salidaa != null) {
                    setHoraHasta(salidaa)
                    setselectMarcacion(OPCIONES_SELECT_MARCACION[0]);
                }
                else if (entradaa != null && salidaa == null)
                    setselectMarcacion(OPCIONES_SELECT_MARCACION[1]);
                else if (entradaa == null && salidaa == null)
                    setselectMarcacion(OPCIONES_SELECT_MARCACION[2]);
            }
            if (tipo === "E") {
                // var horadesde = datosMarcacion.marcacion_horario.horasalidal.split(":")[0] + ":" + datosMarcacion.marcacion_horario.horasalidal.split(":")[1];
                // var fechaEscogida = new Date();
                // var tiempoAlmuerzo = exceso.split(':');
                // var tiempoAlmuerzoMinutos = (+tiempoAlmuerzo[0]) * 60 + (+tiempoAlmuerzo[1]);
                // var [hora_desde, minuto_desde] = horadesde.split(":");
                // fechaEscogida.setHours(Number(hora_desde), Number(minuto_desde) + +tiempoAlmuerzoMinutos, 0);
                // var horahasta = fechaEscogida.getHours() + ":" + fechaEscogida.getMinutes();
                // setHoraDesde(horadesde);
                // setHoraHasta(horahasta);
                setexcesoMarcacion(exceso)
            }

            setstateModalJustificacionES({ ...stateModalJustificacionES, loadingInformacion: true, fecha: fecha, entrada: entradaa, salida: salidaa, tipo: tipo, exceso: exceso })
            //setstateModalDetalleES({ tabladetalle: undefined, loadingInformacion: false, fecha: "" })
            setstateModalJustificacionES({ tabladetalle: undefined, loadingInformacion: false, fecha: fecha, entrada: entradaa, salida: fecha2.toLocaleTimeString(), tipo: tipo, exceso: exceso, url: "", tipojornada: jornada })
        }
        //ASUMIMOS QUE ESTO ES SOLO PARA DIRECTIVOS
        else if (jornada === "L") {
            var nuevafecha = new Date();
            if (entradaa != null)
                nuevafecha.setHours(Number(entradaa.split(":")[0]), Number(entradaa.split(":")[1]), 0);
            else
                nuevafecha.setHours(8, 0, 0);

            var fecha2 = AgregarHoraAFecha(nuevafecha, "8:30");

            if (tipo === "A") {
                if (entradaa != null) {
                    var horaentrada = entradaa.split(":")[0] + ":" + entradaa.split(":")[1];
                    var [hora_desde, minuto_desde] = horaentrada.split(":");
                    var fechaEscogida = new Date();
                    fechaEscogida.setHours(16, 30, 0);
                    var horahasta = fechaEscogida.getHours() + ":" + fechaEscogida.getMinutes();
                    setHoraDesde(horaentrada);
                    setHoraHasta(horahasta);
                }
                if (entradaa == null && salidaa != null) {
                    setHoraHasta(salidaa);

                    setselectMarcacion(OPCIONES_SELECT_MARCACION[3]);
                }

                else if (entradaa != null && salidaa == null)
                    setselectMarcacion(OPCIONES_SELECT_MARCACION[4]);
                else if (entradaa == null && salidaa == null) {
                    setHoraDesde("08:00");
                    setHoraHasta("16:30");
                    setselectMarcacion(OPCIONES_SELECT_MARCACION[5]);
                }

            }
            if (tipo === "E") {
                var horadesde = datosMarcacion.marcacion_horario.horasalidal.split(":")[0] + ":" + datosMarcacion.marcacion_horario.horasalidal.split(":")[1];
                var fechaEscogida = new Date();
                var tiempoNoLaborado = exceso.split(':');
                var tiempoNoLaboradoMinutos = (+tiempoNoLaborado[0]) * 60 + (+tiempoNoLaborado[1]);
                var [hora_desde, minuto_desde] = horadesde.split(":");
                fechaEscogida.setHours(Number(hora_desde), Number(minuto_desde) + +tiempoNoLaboradoMinutos, 0);
                var horahasta = fechaEscogida.getHours() + ":" + fechaEscogida.getMinutes();
                setHoraDesde(horadesde);
                setHoraHasta(horahasta);
            }
            setstateModalJustificacionES({ tabladetalle: undefined, loadingInformacion: false, fecha: fecha, entrada: entradaa, salida: fecha2.toLocaleTimeString(), tipo: tipo, exceso: exceso, url: "", tipojornada: jornada })
        }

    }




    const contenidoModalDetalleES: any = useMemo(() => {

        var fechaActual = new Date();
        fechaActual = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), fechaActual.getDate(), 0, 0);


        if (stateModalDetalleES.loadingInformacion) {
            return <Cargando />
        }
        else if (stateModalDetalleES.tabladetalle !== undefined && stateModalDetalleES.tabladetalle.length === 0) {
            return (
                <>
                    <br />
                    <p className='text-center'>No hay detalle</p>
                </>
            )
        }
        else if (stateModalDetalleES.tabladetalle !== undefined && stateModalDetalleES.loadingInformacion === false) {
            const datosUsuario = authenticationService.currentUserValue.token;
            const tabla =

                <div className="table-responsive containertablaDetalleMarcaciones">
                    <Table bordered className=" tableMarcacionesDetalle tableHistorialSolicitudesVacaciones">
                        <thead className="cabecerasDetallehistorialSolic">
                            <tr className="" >
                                <th> Fecha</th>
                                <th> Hora inicio labores</th>
                                <th> Hora inicio receso</th>
                                <th> Hora fin receso</th>
                                <th> Hora fin labores</th>
                                <th> Total horas</th>
                                <th> Duración receso</th>
                                <th> Estado laboral</th>
                                <th> Estado receso</th>
                                <th> Acciones laboral</th>
                                <th> Acciones receso</th>
                                <th> Estado solicitud laboral</th>
                                <th> Estado solicitud receso</th>
                                <th> Documento</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                stateModalDetalleES.tabladetalle.map((infoDetalle, indinfoHist) => {
                                    const estados = ESTADOS_CON_NOVEDAD;
                                    const classNameEstadoNovedadA: string = estados.includes(infoDetalle.estadoa) ? "estadoNovedadMarcacion" : "";
                                    const classNameEstadoNovedadL: string = estados.includes(infoDetalle.estadol) ? "estadoNovedadMarcacion" : "";
                                    // const mensajeExpiracionViene = infoDetalle.fechaVencimiento && infoDetalle.estadosolicituda !== "A" && infoDetalle.estadosolicituda !== "J" && infoDetalle.estadosolicituda !== "V";
                                    // const mensajeSolicitudExpiro = infoDetalle.fechaVencimiento && infoDetalle.cantidadSolicitudesVencidas < 2 &&  infoDetalle.estadosolicituda === "V" && fechaActual.getTime() > new Date(infoDetalle.fechaVencimiento).getTime()

                                    const fechaVencimientoLaboral =    ""// infoDetalle.fechaVencimientol ? ObtenerFechaLaboralDeSuma(infoDetalle.fechaVencimientol, 1, datosMarcacion.feriados).toISOString() : undefined;
                                    const fechaVencimientoReceso =     ""//  infoDetalle.fechaVencimientoa ? ObtenerFechaLaboralDeSuma(infoDetalle.fechaVencimientoa, 1, datosMarcacion.feriados).toISOString() : undefined;
                                    const fechaVencimientoRecesoDate = ""//  infoDetalle.fechaVencimientoa ? ObtenerFechaLaboralDeSuma(infoDetalle.fechaVencimientoa, 1, datosMarcacion.feriados) : undefined;

                                    const disableChecka = true// (infoDetalle.justificara !== "E" && infoDetalle.justificara !== "A") || infoDetalle.fechaPlazoSolicituda !== undefined && infoDetalle.fechaPlazoSolicituda !== null && fechaActual.getTime() > new Date(infoDetalle.fechaPlazoSolicituda).getTime() || (fechaVencimientoRecesoDate !== undefined && fechaVencimientoRecesoDate !== null && fechaActual.getTime() > fechaVencimientoRecesoDate.getTime());
                                    const disableCheckl = (infoDetalle.justificarl !== "E" && infoDetalle.justificarl !== "A") || infoDetalle.fechaPlazoSolicitudl !== undefined && infoDetalle.fechaPlazoSolicitudl !== null && fechaActual.getTime() > new Date(infoDetalle.fechaPlazoSolicitudl).getTime();

                                    //LO DE ABAJO ES POR SI QUIEREN QUITAR EL MENSAJE DE QUE TIENE PLAZO HASTA SOLICITAR, SI ES QUE AUN NO TERMINA DE MARCAR
                                    //const [horaSalidal, minutoSalidal, segundosSalidal] = datosMarcacion.marcacion_horario.horasalidal.split(":");
                                    //const [diaEvento, mesEvento, anioEvento] = infoDetalle.fecha.split("/")

                                    //const fechaEvento = new Date(+anioEvento, +mesEvento - 1, +diaEvento,0,0,0);
                                    //const fechaHoraSalidal = new Date(fechaEvento.getFullYear(), fechaEvento.getMonth(), fechaEvento.getDate(), +horaSalidal, +minutoSalidal, 0);
                                    var filasEstadosDetalleEntradaSalida = <div></div>

                                    if (infoDetalle.finSemanaFeriado) {
                                        filasEstadosDetalleEntradaSalida = (
                                            <td colSpan={7}>
                                                <div className="small-error">
                                                    {"FIN DE SEMANA/FERIADO"}
                                                </div>
                                            </td>
                                        )
                                    }
                                    else {
                                        filasEstadosDetalleEntradaSalida = (
                                            <React.Fragment>
                                                <td className="">
                                                    <div className={classNameEstadoNovedadL}>

                                                        {infoDetalle.estadol}
                                                    </div>
                                                </td>
                                                <td className="">
                                                    <div className={classNameEstadoNovedadA}>
                                                        {infoDetalle.estadoa}
                                                    </div>
                                                </td>
                                                <td>
                                                    {(infoDetalle.justificarl == "A") ?
                                                        <>
                                                            <input type="checkbox" defaultValue="A" readOnly disabled={disableCheckl} checked={infoDetalle.mensajel != null ? true : false} onClick={() => verJutificacionES(infoDetalle.fecha, infoDetalle.entradal, infoDetalle.salidal, infoDetalle.justificarl, infoDetalle.tiempoincumplimientolaboral, "L")}></input>
                                                            {infoDetalle.mensajel != null ? infoDetalle.mensajel : ""}
                                                        </>
                                                        :
                                                        <>
                                                            <div />
                                                        </>}
                                                </td>
                                                <td>
                                                    {(infoDetalle.justificara == "E" || infoDetalle.justificara == "A") ?
                                                        <>
                                                            <input type="checkbox" defaultValue="A" readOnly disabled={disableChecka} checked={infoDetalle.mensajea != null ? true : false} onClick={() => verJutificacionES(infoDetalle.fecha, infoDetalle.entradaa, infoDetalle.salidaa, infoDetalle.justificara, infoDetalle.excesoa)}></input>
                                                            {infoDetalle.mensajea != null ? infoDetalle.mensajea : ""}
                                                        </>
                                                        :
                                                        <>
                                                            {/* {infoDetalle.mensajea != null ? infoDetalle.mensajea : ""} */}
                                                        </>}
                                                </td>
                                                <td>

                                                    <div>{infoDetalle.estadosolicitudnombrel}</div>
                                                    {
                                                        infoDetalle.fechaPlazoSolicitudl && fechaActual.getTime() <= new Date(infoDetalle.fechaPlazoSolicitudl).getTime() && //&& fechaActual.getTime() > fechaHoraSalidal.getTime() &&
                                                        <small className='small-error-big'>
                                                            {"Puede realizar una solicitud hasta el " + ObtenerFechaFromIsoFormat(infoDetalle.fechaPlazoSolicitudl.toString())}
                                                        </small>
                                                    }
                                                    {
                                                        infoDetalle.fechaPlazoSolicitudl && fechaActual.getTime() > new Date(infoDetalle.fechaPlazoSolicitudl).getTime() &&
                                                        <small className='small-error-big'>
                                                            {"El plazo para solicitar venció"}
                                                        </small>
                                                    }
                                                    {
                                                        infoDetalle.fechaVencimientol && ValidarMensajeExpiracionProxima(infoDetalle, "L") &&
                                                        <TdSeeMoreContent
                                                            text={"Su solicitud expira el " + ObtenerFechaFromIsoFormat(infoDetalle.fechaVencimientol.toString()) + " gestione su aprobación con su directivo"}
                                                            lengthToSee={60}
                                                        />
                                                    }
                                                    {
                                                        !infoDetalle.fechaVencimientoRecuperacionl && infoDetalle.fechaVencimientol && ValidarMensajeSolicitudExpirada(infoDetalle, "L", fechaActual) &&
                                                        <TdSeeMoreContent
                                                            text={"Su solicitud expiró el " + ObtenerFechaFromIsoFormat(infoDetalle.fechaVencimientol.toString()) + ". Puede solicitar 1 vez más hasta el " + ObtenerFechaFromIsoFormat(fechaVencimientoLaboral)}
                                                            lengthToSee={60}
                                                        />
                                                    }
                                                    {/* {
                                                    infoDetalle.fechaVencimientol && ValidarMensajeExpiracionProxima(infoDetalle, "L") &&
                                                    <TdSeeMoreContent
                                                        text={"Su solicitud expira el " + ObtenerFechaFromIsoFormat(infoDetalle.fechaVencimientol.toString()) + ". Gestione su aprobación con su directivo"}
                                                        lengthToSee={60}
                                                    />
                                                }
                                                {
                                                    infoDetalle.fechaVencimientol && ValidarMensajeSolicitudExpirada(infoDetalle, "L", fechaActual) &&
                                                    <TdSeeMoreContent
                                                        text={"Su solicitud expiró el " + ObtenerFechaFromIsoFormat(infoDetalle.fechaVencimientol.toString()) + ". Puede solicitar 1 vez más hasta 1 día laboral después de la última fecha de expiración en el mismo mes"}
                                                        lengthToSee={60}
                                                    />
                                                } */}

                                                </td>
                                                <td>

                                                    <div>{infoDetalle.estadosolicitudnombrea}</div>
                                                    {
                                                        infoDetalle.fechaPlazoSolicituda && fechaActual.getTime() <= new Date(infoDetalle.fechaPlazoSolicituda).getTime() &&
                                                        <small className='small-error-big'>
                                                            {"Puede realizar una solicitud hasta el " + ObtenerFechaFromIsoFormat(infoDetalle.fechaPlazoSolicituda.toString())}
                                                        </small>
                                                    }
                                                    {
                                                        infoDetalle.fechaPlazoSolicituda && fechaActual.getTime() > new Date(infoDetalle.fechaPlazoSolicituda).getTime() &&
                                                        <small className='small-error-big'>
                                                            {"El plazo para solicitar venció"}
                                                        </small>
                                                    }
                                                    {
                                                        infoDetalle.fechaVencimientoa && ValidarMensajeExpiracionProxima(infoDetalle, "A") &&
                                                        <TdSeeMoreContent
                                                            text={"Su solicitud caduca el " + ObtenerFechaFromIsoFormat(infoDetalle.fechaVencimientoa.toString()) + " gestione su aprobación con su directivo"}
                                                            lengthToSee={60}
                                                        />
                                                    }
                                                    {
                                                        !infoDetalle.fechaVencimientoRecuperaciona && infoDetalle.fechaVencimientoa && ValidarMensajeSolicitudExpirada(infoDetalle, "A", fechaActual) &&
                                                        <TdSeeMoreContent
                                                            text={"Su solicitud caducó el " + ObtenerFechaFromIsoFormat(infoDetalle.fechaVencimientoa.toString()) + ". Puede solicitar 1 vez más hasta el " + ObtenerFechaFromIsoFormat(fechaVencimientoReceso)}
                                                            lengthToSee={60}
                                                        />
                                                    }
                                                    {
                                                        infoDetalle.fechaVencimientoRecuperaciona && fechaVencimientoRecesoDate && ValidarMensajeSolicitudRecuperacionNoEjecutada(infoDetalle, "A", fechaActual, fechaVencimientoRecesoDate) &&
                                                        <TdSeeMoreContent
                                                            text={"Esta recuperación NO fue ejecutada. Puede solicitar 1 vez más hasta el " + ObtenerFechaFromIsoFormat(fechaVencimientoReceso)}
                                                            lengthToSee={60}
                                                        />
                                                    }
                                                    {
                                                        infoDetalle.fechaVencimientoRecuperaciona && fechaVencimientoRecesoDate && ValidarMensajeSolicitudRecuperacionNoEjecutadaVencida(infoDetalle, "A", fechaActual, fechaVencimientoRecesoDate) &&
                                                        <TdSeeMoreContent
                                                            text={"Esta recuperación NO fue ejecutada. El plazo para solicitar VENCIÓ el " + ObtenerFechaFromIsoFormat(fechaVencimientoReceso)}
                                                            lengthToSee={60}
                                                        />
                                                    }
                                                </td>
                                                <td>
                                                    {
                                                        (infoDetalle.estadosolicituda === "J" || infoDetalle.estadosolicituda === "O" || infoDetalle.estadosolicituda === "A") &&
                                                        <div className="align-self-center ml-2">
                                                            <i className="fas fa-file-pdf opcion_formulario_pdf "
                                                                onClick={() => DownloadDocument(infoDetalle.referenciaa, datosUsuario, "formulario")}
                                                                data-toggle="tooltip" data-placement="top" title="Descargar formulario almuerzo/receso"
                                                            >

                                                            </i>
                                                        </div>
                                                    }
                                                    {
                                                        (infoDetalle.estadosolicitudl === "J" || infoDetalle.estadosolicitudl === "O" || infoDetalle.estadosolicitudl === "A") &&
                                                        <div className="align-self-center ml-2">
                                                            <i className="fas fa-file-pdf opcion_formulario_pdf "
                                                                onClick={() => DownloadDocument(infoDetalle.referencial, datosUsuario, "formulario")}
                                                                data-toggle="tooltip" data-placement="top" title="Descargar formulario laboral"
                                                            >

                                                            </i>
                                                        </div>
                                                    }
                                                </td>
                                            </React.Fragment>
                                        )
                                    }

                                    return (
                                        <tr className="rowHistorialSolicitudVacaciones" key={"rowDetalleES " + indinfoHist}>
                                            <td className="">
                                                <div className="">
                                                    {infoDetalle.fecha}
                                                </div>
                                            </td>
                                            <td className="">
                                                <div className="">
                                                    {infoDetalle.entradal}
                                                </div>
                                            </td>
                                            <td className="">
                                                <div className="">
                                                    {infoDetalle.entradaa}
                                                </div>
                                            </td>
                                            <td className="">
                                                <div className="">
                                                    {infoDetalle.salidaa}
                                                </div>
                                            </td>
                                            <td className="">
                                                <div className="">
                                                    {infoDetalle.salidal}
                                                </div>
                                            </td>
                                            <td className="">
                                                <div className="">
                                                    {infoDetalle.duracionl}
                                                </div>
                                            </td>
                                            <td className="">
                                                <div className="">
                                                    {infoDetalle.duraciona}
                                                </div>
                                            </td>
                                            {
                                                filasEstadosDetalleEntradaSalida
                                            }

                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </Table>
                </div>

            return tabla;
        }
    }, [stateModalDetalleES, datosMarcacion])

    async function verDetalleES(fecha: string) {
        setstateModalDetalleES({ ...stateModalDetalleES, loadingInformacion: true, fecha: fecha })
        const respuestaRequestDetalle: ResponseRequest = await obtenerDetalleES(fecha);
        if (respuestaRequestDetalle.status !== 200 || respuestaRequestDetalle.dataResponse === undefined) {
            setstateModalDetalleES({ ...stateModalDetalleES, loadingInformacion: false })
            alertService.error(respuestaRequestDetalle.errorMessage ?? "Ha ocurrido un inconveniente al intentar obtener la información.")
            return
        }
        const data: InformacionDetalleES = respuestaRequestDetalle.dataResponse;
        setstateModalDetalleES({ tabladetalle: data.tabladetalle, loadingInformacion: false, fecha: fecha })
    }

    const BotonGenerarRegistrarMarcacionE = useMemo(() => {
        // if (datosMarcacion.marcacion_horario.puedemarcarl == "S" && datosMarcacion.marcacion_dia?.entradaa == null && datosMarcacion.marcacion_dia?.salidaa == null && datosMarcacion.marcacion_dia?.entradal == null && datosMarcacion.marcacion_dia?.salidal == null)
        //     return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled={loading} onClick={() => HandleClickRegistrarMarcacionE()}>Marcar inicio labores</Button>)
        // else if (datosMarcacion.marcacion_horario.puedemarcarl == "N")
        //     return (datosMarcacion.marcacion_horario.mensaje)
        // else
        //     return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar inicio labores</Button>)

        if (datosMarcacion.marcacion_horario.puedemarcarl == "S") {

            if (datosMarcacion.marcacion_horario.puedemarcarlE === "S") {

                return (
                    <BotonMarcacionEntradaSalida
                        disabled={loading}
                        tipoJornada={TipoJornadaBotonMarcacion.LABORAL}
                        tipoSituacion={TipoSituacionBotonMarcacion.ENTRADA}
                        onClickButton={() => HandleClickRegistrarMarcacionE()}
                        className={"twoButtosMarcacion"}
                    />


                )
                // return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled={loading} onClick={() => HandleClickRegistrarMarcacionE()}>Marcar inicio labores</Button>)
            }
            else {
                // return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar inicio labores</Button>)
                return (
                    <BotonMarcacionEntradaSalida
                        disabled={true}
                        tipoJornada={TipoJornadaBotonMarcacion.LABORAL}
                        tipoSituacion={TipoSituacionBotonMarcacion.ENTRADA}
                        className={"twoButtosMarcacion"}

                    />


                )
            }
        }
        else if (datosMarcacion.marcacion_horario.puedemarcarl == "N")
            return (datosMarcacion.marcacion_horario.mensaje)
        else {
            // return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar inicio labores</Button>)
            return (
                <BotonMarcacionEntradaSalida
                    disabled={true}
                    tipoJornada={TipoJornadaBotonMarcacion.LABORAL}
                    tipoSituacion={TipoSituacionBotonMarcacion.ENTRADA}
                    className={"twoButtosMarcacion"}

                />


            )
        }


    }, [loading, datosMarcacion]);

    const BotonGenerarRegistrarMarcacionS = useMemo(() => {
        // if (datosMarcacion.marcacion_horario.puedemarcarl === "S" && datosMarcacion.marcacion_dia.salidal === null)
        //     return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled={loading} onClick={() => HandleClickRegistrarMarcacionS()}>Marcar fin labores</Button>)
        // else if (datosMarcacion.marcacion_horario.puedemarcarl == "S" && datosMarcacion.marcacion_dia?.entradal != null && datosMarcacion.marcacion_dia?.salidal == null && datosMarcacion.marcacion_dia?.entradaa != null && datosMarcacion.marcacion_dia?.salidaa == null) {
        //     if (date.getTime() < new Date().setHours(15, 0, 0))
        //         return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar fin labores (debe marcar la salida del receso)</Button>)
        //     else
        //         return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled={loading} onClick={() => HandleClickRegistrarMarcacionS()}>Marcar fin labores</Button>)
        // }
        // else if (datosMarcacion.marcacion_horario.puedemarcarl == "S" && datosMarcacion.marcacion_dia?.entradal != null && datosMarcacion.marcacion_dia?.salidal == null) {
        //     if (date.getTime() < new Date().setHours(12, 0, 0) || date.getTime() > new Date().setHours(15, 0, 0))
        //         return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled={loading} onClick={() => HandleClickRegistrarMarcacionS()}>Marcar fin labores</Button>)
        //     else
        //         return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar fin labores</Button>)
        // }
        // else if (datosMarcacion.marcacion_horario.puedemarcarl == "N")
        //     return ("")
        // else
        //     return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar fin labores</Button>)






        if (datosMarcacion.marcacion_horario.puedemarcarl === "S") {

            if (datosMarcacion.marcacion_horario.puedemarcarlS === "S") {

                const [horaentradaalmuerzo, minutoentradaalmuerzo] = datosMarcacion.marcacion_horario.horaentradaa.split(":")
                const [horasalidalmuerzo, minutosalidaalmuerzo] = datosMarcacion.marcacion_horario.horasalidaa.split(":")

                //*************SOLO PARA PRUEBAS****************///
                //const horarioPrueba = new Date(date.getFullYear(),date.getMonth(),date.getDate(),12,15);
                const horarioPrueba = date;

                const horarioCompararEntrada = new Date(date.getFullYear(), date.getMonth(), date.getDate(), +horaentradaalmuerzo, +minutoentradaalmuerzo);
                const horarioCompararSalida = new Date(date.getFullYear(), date.getMonth(), date.getDate(), +horasalidalmuerzo, +minutosalidaalmuerzo);

                if (horarioCompararEntrada.getTime() <= horarioPrueba.getTime() && horarioPrueba.getTime() <= horarioCompararSalida.getTime() && datosMarcacion.marcacion_dia.entradaa !== null && datosMarcacion.marcacion_dia?.salidaa === null) {
                    // return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar fin labores</Button>)
                    return (

                        <BotonMarcacionEntradaSalida
                            disabled={true}
                            tipoJornada={TipoJornadaBotonMarcacion.LABORAL}
                            tipoSituacion={TipoSituacionBotonMarcacion.SALIDA}
                            className={"twoButtosMarcacion"}
                        />
                    )
                }

                // return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled={loading} onClick={() => HandleClickRegistrarMarcacionS()}>Marcar fin labores</Button>)
                return (

                    <BotonMarcacionEntradaSalida
                        disabled={loading}
                        tipoJornada={TipoJornadaBotonMarcacion.LABORAL}
                        tipoSituacion={TipoSituacionBotonMarcacion.SALIDA}
                        onClickButton={() => HandleClickRegistrarMarcacionS()}
                        className={"twoButtosMarcacion"}
                    />
                )
            }
            else {
                // return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar fin labores</Button>)
                return (

                    <BotonMarcacionEntradaSalida
                        disabled={true}
                        tipoJornada={TipoJornadaBotonMarcacion.LABORAL}
                        tipoSituacion={TipoSituacionBotonMarcacion.SALIDA}
                        className={"twoButtosMarcacion"}
                    />
                )
            }
        }
        else if (datosMarcacion.marcacion_horario.puedemarcarl == "N")
            return ("")
        else {
            // return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar fin labores</Button>)

            return (

                <BotonMarcacionEntradaSalida
                    disabled={true}
                    tipoJornada={TipoJornadaBotonMarcacion.LABORAL}
                    tipoSituacion={TipoSituacionBotonMarcacion.SALIDA}
                    className={"twoButtosMarcacion"}
                />
            )
        }
    }, [loading, datosMarcacion]);

    const BotonGenerarRegistrarMarcacionEA = useMemo(() => {
        // if (datosMarcacion.marcacion_horario.puedemarcara == "S"  && datosMarcacion.marcacion_dia?.entradaa == null && datosMarcacion.marcacion_dia?.salidaa == null && datosMarcacion.marcacion_dia?.salidal == null)
        //     if (date.getTime() > new Date().setHours(12, 0, 0) && date.getTime() <= new Date().setHours(14, 30, 0))
        //         return (<Button className="primary btn-success" type="button" style={{ float: 'inherit' }} disabled={loading} onClick={() => HandleClickRegistrarMarcacionEA()}>Marcar inicio receso/almuerzo</Button>)
        //     else
        //         return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar inicio receso/almuerzo</Button>)
        // else if (datosMarcacion.marcacion_horario.puedemarcara == "N")
        //     return ("")
        // else
        //     return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar inicio receso/almuerzo</Button>)


        if (datosMarcacion.marcacion_horario.puedemarcara === "S") {
            if (datosMarcacion.marcacion_horario.puedemarcaraE === "S") {
                // return (<Button className="primary btn-success" type="button" style={{ float: 'inherit' }} disabled={loading} onClick={() => HandleClickRegistrarMarcacionEA()}>Marcar inicio receso/almuerzo</Button>)

                return (
                    <BotonMarcacionEntradaSalida
                        disabled={loading}
                        tipoJornada={TipoJornadaBotonMarcacion.ALMUERZO}
                        tipoSituacion={TipoSituacionBotonMarcacion.ENTRADA}
                        onClickButton={() => HandleClickRegistrarMarcacionEA()}
                        className={"twoButtosMarcacion"}
                    />


                )
            }
            else {
                // return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar inicio receso/almuerzo</Button>)

                return (
                    <BotonMarcacionEntradaSalida
                        disabled={true}
                        tipoJornada={TipoJornadaBotonMarcacion.ALMUERZO}
                        tipoSituacion={TipoSituacionBotonMarcacion.ENTRADA}
                        className={"twoButtosMarcacion"}

                    />


                )
            }
        }
        else if (datosMarcacion.marcacion_horario.puedemarcara === "N")
            return ("")
        else {
            // return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar inicio receso/almuerzo</Button>)
            return (
                <BotonMarcacionEntradaSalida
                    disabled={true}
                    tipoJornada={TipoJornadaBotonMarcacion.ALMUERZO}
                    tipoSituacion={TipoSituacionBotonMarcacion.ENTRADA}
                    className={"twoButtosMarcacion"}

                />


            )
        }

    }, [loading, datosMarcacion]);

    const BotonGenerarRegistrarMarcacionSA = useMemo(() => {
        // if (datosMarcacion.marcacion_horario.puedemarcara == "S"  && datosMarcacion.marcacion_dia?.salidaa == null && datosMarcacion.marcacion_dia?.salidal == null) {
        //     if ( datosMarcacion.marcacion_dia?.entradaa !== null && date.getTime() > new Date().setHours(12, 0, 0) && date.getTime() <= new Date().setHours(15, 0, 0)) {
        //         var startDate = new Date(0, 0, 0, parseInt(datosMarcacion.marcacion_dia?.entradaa.split(':')[0]), parseInt(datosMarcacion.marcacion_dia?.entradaa.split(':')[1]));
        //         var endDate = new Date(0, 0, 0, date.getHours(), date.getMinutes());
        //         var diff = (endDate.getTime() - startDate.getTime()) / 1000;
        //         diff /= 60;
        //         if (Math.abs(Math.round(diff)) > 10)
        //             return (<Button className="primary btn-success" type="button" style={{ float: 'inherit' }} disabled={loading} onClick={() => HandleClickRegistrarMarcacionSA()}>Marcar fin receso/almuerzo</Button>)
        //         else
        //             return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar fin receso/almuerzo</Button>)
        //     }
        //     else if (datosMarcacion.marcacion_dia?.entradaa === null && date.getTime() > new Date().setHours(12, 0, 0) && date.getTime() <= new Date().setHours(15, 0, 0)) {
        //         return (<Button className="primary btn-success" type="button" style={{ float: 'inherit' }} disabled={loading} onClick={() => HandleClickRegistrarMarcacionSA()}>Marcar fin receso/almuerzo</Button>)
        //     }
        //     else
        //         return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar fin receso/almuerzo</Button>)
        // }
        // else if (datosMarcacion.marcacion_horario.puedemarcara == "N")
        //     return ("")
        // else
        //     return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar fin receso/almuerzo</Button>)

        if (datosMarcacion.marcacion_horario.puedemarcara === "S") {
            if (datosMarcacion.marcacion_horario.puedemarcaraS === "S") {

                //if (datosMarcacion.marcacion_dia?.entradaa !== null) {
                //var startDate = new Date(0, 0, 0, parseInt(datosMarcacion.marcacion_dia?.entradaa.split(':')[0]), parseInt(datosMarcacion.marcacion_dia?.entradaa.split(':')[1]));
                //var endDate = new Date(0, 0, 0, date.getHours(), date.getMinutes());
                //var diff = (endDate.getTime() - startDate.getTime()) / 1000;
                //diff /= 60;
                //if (Math.abs(Math.round(diff)) > 10) {
                // return (<Button className="primary btn-success" type="button" style={{ float: 'inherit' }} disabled={loading} onClick={() => HandleClickRegistrarMarcacionSA()}>Marcar fin receso/almuerzo</Button>)
                return (
                    <BotonMarcacionEntradaSalida
                        disabled={loading}
                        tipoJornada={TipoJornadaBotonMarcacion.ALMUERZO}
                        tipoSituacion={TipoSituacionBotonMarcacion.SALIDA}
                        onClickButton={() => HandleClickRegistrarMarcacionSA()}
                        className={"twoButtosMarcacion"}
                    />


                )

                //}
                //else {
                //    return (
                //        <BotonMarcacionEntradaSalida
                //            disabled={true}
                //            tipoJornada={TipoJornadaBotonMarcacion.ALMUERZO}
                //            tipoSituacion={TipoSituacionBotonMarcacion.SALIDA}
                //            onClickButton={() => HandleClickRegistrarMarcacionSA()}
                //        />
                //    )
                //}
            }
            else {
                // return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar fin receso/almuerzo</Button>)
                return (
                    <BotonMarcacionEntradaSalida
                        disabled={true}
                        tipoJornada={TipoJornadaBotonMarcacion.ALMUERZO}
                        tipoSituacion={TipoSituacionBotonMarcacion.SALIDA}
                        className={"twoButtosMarcacion"}
                    />
                )
            }
        }
        else if (datosMarcacion.marcacion_horario.puedemarcara === "N")
            return ("")
        else {
            // return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar fin receso/almuerzo</Button>)
            return (
                <BotonMarcacionEntradaSalida
                    disabled={true}
                    tipoJornada={TipoJornadaBotonMarcacion.ALMUERZO}
                    tipoSituacion={TipoSituacionBotonMarcacion.SALIDA}
                    className={"twoButtosMarcacion"}
                />
            )
        }


    }, [loading, datosMarcacion]);

    async function GetInfoMarcacion() {
        setloadingDatos(true)
        var userData: UserData = authenticationService.currentUserValue;
        const URL = `${configData.SERVER_URL}RegistroEntradaSalida/InformacionGeneral`;

        try {
            const respuesta = await axios.get(URL, {
                headers: authHeaderWithToken(userData.token),
            })

            var datos = respuesta.data;
            setdatosMarcacion(datos);
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                ;
            }
            handleError();
        }

        setloadingDatos(false);
    }

    useEffect(() => {
        window.location.href = "https://th.espol.edu.ec/";
        //getIp();
        //GetInfoMarcacion();
        //const infoModalMarcacion = localStorage.getItem(KEY_SHOWMODAL_MARCACION_AVISO);
        //if (infoModalMarcacion === null) {
        //    CreateLocalStorageMensajeMarcacion()
        //    setmostrarModalMarcacion(true);
        //}
        //else {
        //    const showInformacion = VerifyShowMensajeMarcacionStorage();
        //    setmostrarModalMarcacion(showInformacion)

        //}

    }, [])

    useEffect(() => {
        //var timer = setInterval(() => setDate(new Date()), 1000)
        var serverTime = new Date(Number(datosMarcacion.marcacion_horario.fechahora));
        var localTime = new Date();
        var timeDiff = serverTime.getTime() - localTime.getTime();

        var timer = setInterval(() => setDate(new Date((new Date().getTime() + timeDiff))), 1000)

        return function cleanup() {
            clearInterval(timer)
        }
    }, [datosMarcacion]);

    const contenidoMensajeAlerta = (
        <div>
            {"Su horario laboral es de 08:00 a 16:30. El rango de horas para el receso es desde las 12h00 hasta las 15h00. La duración del receso es de 30 minutos."}
        </div>
    )

    const contenidoModalImagen = (
        <div style={{ textAlign: "center" }}>
            <img
                className={"containerBanner"}
                src={COMUNICADOMARCACION} alt="comunicadoMarcacion"></img>
        </div>

    )



    if (loadingDatos) {
        return <Cargando />
    }

    return (
        <div className="content">
            <h5 className="title">Registro de marcaciones directivos LOSEP</h5>
            <Row className="">
                <Col md={10}>
                    <AlertNew
                        cabeceraTitulo={"¡¡ADVERTENCIA!!"}
                        mensaje={MENSAJE_ADVERTENCIA_LAPSO_SOLICITUD}
                        tipo={TiposAlerta.ADVERTENCIA}
                        oncloseElement={() => { ; }}
                    />
                </Col>
            </Row>
            <Row className="mb-3">
                <Col md={10}>
                    <AlertNew
                        cabeceraTitulo={"Para su conocimiento"}
                        mensaje={" "}
                        tipo={TiposAlerta.PARA_CONOCIMIENTO}
                        mensajeHTML={contenidoMensajeAlerta}
                        oncloseElement={() => { ; }}
                    />
                </Col>
            </Row>
            {/* <Row>
                <Col xs={{ span: 12, order: 2 }} md={{ span: 7, order: 1 }}>
                    <React.Fragment>
                        <Card>
                            <CardHeader className="blanco text-center cardHeaderRegistrosMarcacionDir" style={{ backgroundColor: "#517ED2" }}>
                                {"Registros de marcaciones"}
                            </CardHeader>
                            <CardBody>
                                <Table bordered className="table_planificacion_vacaciones" >
                                    <thead className="cabeceras_tabla_planificacion_vac">
                                        <tr>
                                            <th colSpan={1}>{"Fecha"}</th>
                                            <th colSpan={1}>{"Hora inicio labores"}</th>
                                            <th colSpan={1}>{"Hora inicio receso"}</th>
                                            <th colSpan={1}>{"Hora fin receso"}</th>
                                            <th colSpan={1}>{"Hora fin labores"}</th>
                                            <th colSpan={1}>{"Total horas"}</th>
                                            <th colSpan={1}>{"Estado laboral"}</th>
                                            <th colSpan={1}>{"Estado receso"}</th>
                                        </tr>
                                    </thead>
                                    <tbody key={"tbodyplanificacionAnio "}>
                                        {
                                            datosMarcacion.lista_registro.map((l_marcacion, i_l_marcacion) => {

                                                const classNameEstadoNovedadA: string = ESTADOS_CON_NOVEDAD.includes(l_marcacion.estadoa) ? "estadoNovedadMarcacion" : "";
                                                const classNameEstadoNovedadL: string = ESTADOS_CON_NOVEDAD.includes(l_marcacion.estadol) ? "estadoNovedadMarcacion" : "";

                                                return (

                                                    <tr className="rows_tabla_planificacion_vac_directivo" key={i_l_marcacion} >
                                                        <td>
                                                            {l_marcacion.fecha}
                                                        </td>
                                                        <td>
                                                            {l_marcacion.entradal}
                                                        </td>
                                                        <td>
                                                            {l_marcacion.entradaa}
                                                        </td>
                                                        <td>
                                                            {l_marcacion.salidaa}
                                                        </td>
                                                        <td>
                                                            {l_marcacion.salidal}
                                                        </td>
                                                        <td>
                                                            {l_marcacion.duracionl}
                                                        </td>
                                                        <td>
                                                            <div className={classNameEstadoNovedadL}>
                                                                {l_marcacion.estadol}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className={classNameEstadoNovedadA}>
                                                                {l_marcacion.estadoa}
                                                            </div>

                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        <tr className="rows_tabla_planificacion_vac_directivo">
                                            <td colSpan={6}>
                                                {" "}
                                            </td>
                                            <td colSpan={2}>
                                                <span style={{ cursor: "pointer" }} onClick={() => verDetalleES(datosMarcacion.marcacion_horario.fecha)}>
                                                    {"Ver más"}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </React.Fragment>
                </Col>
            </Row> */}
            <Row>

                {/* <Col xs={{ span: 12, order: 1 }} md={{ span: 5, order: 2 }}> */}
                <Col xl={12}>
                    <Card>
                        <CardHeader className="blanco text-center cardHeaderRegistraMarcacionDir" style={{ backgroundColor: "#00A6E0" }}>
                            {"Registre su marcación"}
                        </CardHeader>
                        <CardBody>
                            <div>
                                <span className="gris">Fecha y hora: &nbsp;</span>
                            </div>
                            <div className="containerFechaHoraDiaFin">
                                <div className="fitem-containerFechaHoraDiaFin-1">
                                    <i className="fa-regular fa-calendar"></i> {date.toLocaleDateString()} &nbsp;&nbsp;&nbsp;
                                </div>
                                <div className="fitem-containerFechaHoraDiaFin-2">
                                    <i className="fa-regular fa-clock"></i> {date.toLocaleTimeString()}
                                </div>

                            </div>
                            {
                                loading && <Cargando />
                            }
                            {
                                !loading &&
                                <>
                                    <Row className='mt-3'>
                                        <Col md={3} xl={3} xs={6}  > {BotonGenerarRegistrarMarcacionE} </Col>
                                        <Col md={3} xl={3} xs={6}  > {BotonGenerarRegistrarMarcacionEA} </Col>
                                        <Col md={3} xl={3} xs={6} className={"smallMarginTopBtnMarcacion"}> {BotonGenerarRegistrarMarcacionSA} </Col>
                                        <Col md={3} xl={3} xs={6} className={"smallMarginTopBtnMarcacion"}> {BotonGenerarRegistrarMarcacionS} </Col>
                                    </Row>
                                    <Table bordered className="table_planificacion_vacaciones" >
                                        <thead className="cabeceras_tabla_planificacion_vac">
                                            <tr>
                                                <th colSpan={1}>{"Fecha"}</th>
                                                <th colSpan={1}>{"Hora inicio labores"}</th>
                                                <th colSpan={1}>{"Hora inicio receso"}</th>
                                                <th colSpan={1}>{"Hora fin receso"}</th>
                                                <th colSpan={1}>{"Hora fin labores"}</th>
                                                <th colSpan={1}>{"Total horas"}</th>
                                                <th colSpan={1}>{"Estado laboral"}</th>
                                                <th colSpan={1}>{"Estado receso"}</th>
                                            </tr>
                                        </thead>
                                        <tbody key={"tbodyplanificacionAnio "}>
                                            {
                                            <tr className="rows_tabla_planificacion_vac_directivo" 
                                                // key={i_l_marcacion}
                                                 >
                                                 <td>
                                                     {datosMarcacion.marcacion_dia.fecha}
                                                 </td>
                                                 <td>
                                                     {datosMarcacion.marcacion_dia.entradal}
                                                 </td>
                                                 <td>
                                                     {datosMarcacion.marcacion_dia.entradaa}
                                                 </td>
                                                 <td>
                                                     {datosMarcacion.marcacion_dia.salidaa}
                                                 </td>
                                                 <td>
                                                     {datosMarcacion.marcacion_dia.salidal}
                                                 </td>
                                                 <td>
                                                     {datosMarcacion.marcacion_dia.duracionl}
                                                 </td>
                                                 <td>
                                                     <div 
                                                        // className={classNameEstadoNovedadL}
                                                     >
                                                         {datosMarcacion.marcacion_dia.estadol}
                                                     </div>
                                                 </td>
                                                 <td>
                                                     <div 
                                                        // className={classNameEstadoNovedadA}
                                                     >
                                                         {datosMarcacion.marcacion_dia.estadoa}
                                                     </div>

                                                 </td>
                                             </tr>

                                            }
                                            {/* {
                                                datosMarcacion.lista_registro.map((l_marcacion, i_l_marcacion) => {

                                                    const classNameEstadoNovedadA: string = ESTADOS_CON_NOVEDAD.includes(l_marcacion.estadoa) ? "estadoNovedadMarcacion" : "";
                                                    const classNameEstadoNovedadL: string = ESTADOS_CON_NOVEDAD.includes(l_marcacion.estadol) ? "estadoNovedadMarcacion" : "";

                                                    return (

                                                        <tr className="rows_tabla_planificacion_vac_directivo" key={i_l_marcacion} >
                                                            <td>
                                                                {l_marcacion.fecha}
                                                            </td>
                                                            <td>
                                                                {l_marcacion.entradal}
                                                            </td>
                                                            <td>
                                                                {l_marcacion.entradaa}
                                                            </td>
                                                            <td>
                                                                {l_marcacion.salidaa}
                                                            </td>
                                                            <td>
                                                                {l_marcacion.salidal}
                                                            </td>
                                                            <td>
                                                                {l_marcacion.duracionl}
                                                            </td>
                                                            <td>
                                                                <div className={classNameEstadoNovedadL}>
                                                                    {l_marcacion.estadol}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className={classNameEstadoNovedadA}>
                                                                    {l_marcacion.estadoa}
                                                                </div>

                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            } */}
                                            {/* <tr className="rows_tabla_planificacion_vac_directivo">
                                                <td colSpan={6}>
                                                    {" "}
                                                </td>
                                                <td colSpan={2}>
                                                    <span style={{ cursor: "pointer" }} onClick={() => verDetalleES(datosMarcacion.marcacion_horario.fecha)}>
                                                        {"Ver más"}
                                                    </span>
                                                </td>
                                            </tr> */}
                                        </tbody>
                                    </Table>
                                    <Row>
                                        <Col>
                                            {/*<Link to="https://th.espol.edu.ec/user/informacion-laboral/marcaciones" style={{ textDecoration: 'underline', color: 'blue' }}>*/}
                                            {/*    Ver historial de marcaciones / Ingreso de justificaciones*/}
                                            {/*</Link>*/}
                                            <a
                                                href="https://th.espol.edu.ec/user/informacion-laboral/marcaciones"
                                                style={{ textDecoration: 'underline', color: 'blue' }}
                                            >
                                                Ver historial de marcaciones / Ingreso de justificaciones
                                            </a>
                                        </Col>
                                    </Row>
                                </>

                            }
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <ModalConfirmacion
                show={stateModalDetalleES.tabladetalle !== undefined || stateModalDetalleES.loadingInformacion}
                asyncAccion={false}
                asyncClose={false}
                closeAfterAccion={false}
                hideBotonCerrar={false}
                mensajeConfirmacion={""}
                nombreBotonAccion={"Cerrar"}
                nombreBotonCerrarModal={"Cancelar"}
                onClose={() => setstateModalDetalleES({ tabladetalle: undefined, loadingInformacion: false, fecha: "" })}
                size={"xl"}
                contentModal={contenidoModalDetalleES}
                tituloModal={"Marcaciones"}
                classNameAllModal={""}
            />
            <ModalConfirmacion
                show={stateModalJustificacionES.fecha !== "" || stateModalJustificacionES.loadingInformacion}
                asyncAccion={false}
                asyncClose={false}
                closeAfterAccion={false}
                hideBotonCerrar={false}
                mensajeConfirmacion={""}
                nombreBotonAccion={"Cerrar"}
                nombreBotonCerrarModal={"Cancelar"}
                onClose={() => ReiniciarJustificacionES()}
                size={"lg"}
                classNameContentModal={"contentModalAprSolReintegroVacaciones"}
                contentModal={contenidoModalJustificacionES}
                classNameBotonCerrarModal={{ position: "absolute", zIndex: 9999, marginLeft: "40%" }}
                tituloModal={stateModalJustificacionES.tipo === "E" ? "Solicitud de recuperación de tiempo no laborado" : "Solicitud de justificación de marcación"}
                classNameAllModal={""}
            />

            <ModalConfirmacion
                show={mostrarModalMarcacion && !loadingDatos && !loading}
                centered={true}
                asyncAccion={false}
                asyncClose={false}
                closeAfterAccion={true}
                hideBotonCerrar={true}
                mensajeConfirmacion=''
                contentModal={contenidoModalImagen}
                classNameContentModal='modalBodyBanner'
                classNameContainer='containermodalBanner'
                size='xl'
                nombreBotonAccion='Entendido'
                onClose={() => {
                    setmostrarModalMarcacion(false)
                    CerrarLocalStorageMensajeMarcacion()
                }
                }
                onClick={() => {
                    setmostrarModalMarcacion(false)

                    CerrarLocalStorageMensajeMarcacion()

                }}
            />
        </div>
    )
}


